interface IBuildCarHubPathArgs {
  brand: string | undefined | null
  car: string | undefined | null
  model: string | undefined | null
  fuel: string | undefined | null
}

// 차종/모델명에 포함될 수 있는 '/' 를 path delimiter 와 분리하기 위해
// 전각 슬래시(U+FF0F)로 치환. 라우트 진입 시 denormalize 로 원본 복원.
const normalize = (segment: string) => segment.replaceAll('/', '／')
const denormalize = (segment: string) => segment.replaceAll('／', '/')

// encodeURIComponent 는 `( ) ' ! *` 를 인코딩하지 않고 남긴다. 모델명 코드(예: `SM6(LFD)`)의
// raw 괄호가 인앱 웹뷰의 URL/RSC 경로 처리에서 손상돼 다른 모델로 렌더되는 문제가 있어,
// 세그먼트를 % 이스케이프만 남는 불투명 문자열로 강제 인코딩한다.
const strictEncode = (segment: string) =>
  encodeURIComponent(segment).replace(
    /[()'!*]/g,
    char => `%${char.charCodeAt(0).toString(16).toUpperCase()}`
  )

// 크롤러가 재방문하는 /car/.../null 같은 문자열 'null'·'undefined' 세그먼트를 링크 생성·API 호출에서 거른다.
const SENTINEL_SEGMENTS = new Set(['null', 'undefined'])

export const isSentinelSegment = (segment: string | undefined | null) =>
  !segment || SENTINEL_SEGMENTS.has(segment)

export const buildCarHubPath = ({
  brand,
  car,
  model,
  fuel,
}: IBuildCarHubPathArgs): string | null => {
  const segments = [brand, car, model, fuel]
  if (segments.some(isSentinelSegment)) return null
  return `/car/${segments
    .map(segment => strictEncode(normalize(segment as string)))
    .join('/')}`
}

interface ICarHubRouteParams {
  company: string
  carName: string
  modelName: string
  fuelType: string
}

export const decodeCarHubParams = (params: ICarHubRouteParams) => ({
  brand: denormalize(decodeURIComponent(params.company)),
  car: denormalize(decodeURIComponent(params.carName)),
  model: denormalize(decodeURIComponent(params.modelName)),
  fuel: denormalize(decodeURIComponent(params.fuelType)),
})
